import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import Loading from './Loading'
import { GlobalContext } from '../context/GlobalState'

const Share = () => {
  const context = useContext(GlobalContext)
  const { lists, users, members, getMembers, addMember, removeMember, getAllUsers } = context
//  const [ membersIDs, setMembersIDs ] = useState(null)
  const { listID } = useParams()

   /* get all members who share this list */
   useEffect (() => {
    getMembers(listID)
    getAllUsers()
  //eslint-disable-next-line
  }, [])

  /* remove user from shared list */
  const removeShare = async user => {
    removeMember(user, listID)
  }

  /* add new user to shared list */
  const addShare = async user => {
    addMember(user, listID)
  }

  if(members === null || users === null)
    return <Loading />
  return (
    <div className="all-pages-bg">
      <Header style={'mini'} />
      <div className="list-content">
        <div className="list-info">
          <h5>{lists.filter(list => list.listID === listID)[0].listName}</h5>
          <p>Edit your share settings for this list</p>
        </div>
          <div className="share-list-container">
            <h5>Shared members</h5>
              {members.length === 0 && <p>Not shared</p>}
                {members.map(mem => 
                  <li key={mem.userID}>
                    <i className={"fas fa-user" + mem.avatar}></i>
                    <div className="share-user">{mem.username}<p>{mem.email}</p></div>
                    <button onClick={() => removeShare(mem)}><i className="fas fa-minus"></i></button>
                  </li>
                )}
          </div>

          <div className="share-list-users">
            <h5>Available Users</h5>
              <span className="small"><i className="fas fa-info-circle"></i> Your favorited users are always listed first here</span>
              {users.filter(users => users.friend === 'Y').map(user => <p key={user.userID} onClick= {() => addShare(user)} >{user.username}  <i className="fas fa-heart favorite-icon-small friend-color"></i></p>)}
              {users.filter(users => users.friend !== 'Y').map(user => <p key={user.userID} onClick= {() => addShare(user)} >{user.username}</p>)}
          </div>
      </div>
      <Footer />
    </div>
  )
}

export default Share